import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: {
        cursor: 'default',
        display: 'flex',
        border: 'none !important',

        '.MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            minHeight: '40px !important',
            paddingBottom: '0 !important',
            paddingTop: '0 !important',

            '.language-select__country-name': {
                display: 'none',
            },

            '&[aria-expanded="true"] ~ .MuiSelect-custom-arrow-component': {
                transform: 'rotate(180deg)',
            },
        },
    },
    menuList: {
        '.MuiMenu-list': {
            padding: 0,
        },
    },
    menuItem: {
        padding: '19px 25px',
        color: isHosTheme
            ? `${theme.palette.common.white} !important`
            : `${theme.palette.common.black} !important`,
        background: theme.palette.background.paper,

        '&[aria-selected=true]': {
            background: `${theme.palette.background.paper} !important`,
        },

        ':not(:last-child)': {
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
    },
    icon: {
        width: '22px',
        height: '22px',
        marginRight: 10,
        borderRadius: '50%',
    },

    chevron: css({
        width: isHosTheme ? 24 : 18,
        height: isHosTheme ? 20 : 'auto',
        flexShrink: 0,
        position: 'absolute',
        right: 5,
        pointerEvents: 'none',
        color: isHosTheme ? theme.palette.secondary.light : theme.palette.text.primary,
        strokeWidth: isHosTheme ? 1 : 2.5,
    }),
};
